import React, { useState, useEffect } from "react";
import { auth, database, signOut } from '../firebase'; // Import Firebase services
const publicUrl = process.env.PUBLIC_URL;
const handleLogout = async () => {
  try {
    await signOut(auth);
    console.log('User has been logged out');
    // Redirect or update UI as needed
  } catch (error) {
    console.error('Error logging out: ', error);
  }};

const pronounsList = [
  { code: "001", label: "they/them/theirs" },
  { code: "002", label: "she/her/hers" },
  { code: "003", label: "he/him/his" },
  { code: "004", label: "it/its/its" },
  { code: "005", label: "xe/xem/xys" },
  { code: "006", label: "ey/em/eirs" },
  { code: "007", label: "xe/xer/xers" },
  { code: "008", label: "fae/faer/faers" },
  { code: "051", label: "Any Pronouns" },
  { code: "052", label: "No Pronouns" },
  { code: "053", label: "Ask Pronouns" },
  { code: "101", label: "היא/את" },
  { code: "102", label: "הוא/אתה" },
  { code: "103", label: "הן/אתן" },
  { code: "104", label: "הם/אתם" },
  { code: "105", label: "זה" },
  // Add more pronouns as needed
];
const flagsList = [
  { code: "001", label: "Transgender", imageUrl: `${process.env.PUBLIC_URL}/identitiescard/G-Transgender.png`},
  { code: "002", label: "Transfeminine", imageUrl: `${process.env.PUBLIC_URL}/identitiescard/G-Transfeminine.png`},
  { code: "003", label: "Transneutral", imageUrl: `${process.env.PUBLIC_URL}/identitiescard/G-Transneutral.png`},
  { code: "004", label: "Transmasculine", imageUrl: `${process.env.PUBLIC_URL}/identitiescard/G-Transmasculine.png`},
  { code: "005", label: "Non-Binary", imageUrl: `${process.env.PUBLIC_URL}/identitiescard/G-Nonbinary.png`},
  { code: "006", label: "Agender", imageUrl: `${process.env.PUBLIC_URL}/identitiescard/G-Agender.png`},
  { code: "007", label: "Librafeminine", imageUrl: `${process.env.PUBLIC_URL}/identitiescard/G-Librafeminine.png`},
  { code: "008", label: "Libranrdogyne", imageUrl: `${process.env.PUBLIC_URL}/identitiescard/G-Librandrogyne.png`},
  { code: "009", label: "Libramasculine", imageUrl: `${process.env.PUBLIC_URL}/identitiescard/G-Libramasculine.png`},
  { code: "010", label: "Demigender", imageUrl: `${process.env.PUBLIC_URL}/identitiescard/G-Demigender.png`},
  { code: "011", label: "Demigirl", imageUrl: `${process.env.PUBLIC_URL}/identitiescard/G-Demigirl.png`},
  { code: "012", label: "Demiboy", imageUrl: `${process.env.PUBLIC_URL}/identitiescard/G-Demiboy.png`},
  { code: "013", label: "Paragirl", imageUrl: `${process.env.PUBLIC_URL}/identitiescard/G-Paragirl.jpg`},
  { code: "014", label: "Paraboy", imageUrl: `${process.env.PUBLIC_URL}/identitiescard/G-Paraboy.jpg`},
  { code: "015", label: "Androgyne", imageUrl: `${process.env.PUBLIC_URL}/identitiescard/G-Androgyne.png`},
  { code: "016", label: "Genderqueer", imageUrl: `${process.env.PUBLIC_URL}/identitiescard/G-Genderqueer.png`},
  { code: "017", label: "Genderfluid", imageUrl: `${process.env.PUBLIC_URL}/identitiescard/G-Genderfluid.png`},
  { code: "018", label: "Neutrois", imageUrl: `${process.env.PUBLIC_URL}/identitiescard/G-Neutrois.png`},
  { code: "019", label: "Bigender", imageUrl: `${process.env.PUBLIC_URL}/identitiescard/G-Bigender.png`},
  { code: "020", label: "Trigender", imageUrl: `${process.env.PUBLIC_URL}/identitiescard/G-Trigender.png`},
  { code: "021", label: "Polygender", imageUrl: `${process.env.PUBLIC_URL}/identitiescard/G-Polygender.png`},
  { code: "022", label: "Pangender", imageUrl: `${process.env.PUBLIC_URL}/identitiescard/G-Pangender.png`},
  { code: "023", label: "Two Spirit", imageUrl: `${process.env.PUBLIC_URL}/identitiescard/G-Two Spirit.png`},
  { code: "025", label: "Xenogender", imageUrl: `${process.env.PUBLIC_URL}/identitiescard/G-Xenogender.png`},
  { code: "026", label: "Genderfae", imageUrl: `${process.env.PUBLIC_URL}/identitiescard/G-Genderfae.png`},
  { code: "027", label: "Trans Flag Israel", imageUrl: `${process.env.PUBLIC_URL}/identitiescard/G-Trans Flag Israel.png`},
  { code: "028", label: "Israeli Trans Flag GR", imageUrl: `${process.env.PUBLIC_URL}/identitiescard/G-Israeli Trans Flag GR.png`},
  { code: "101", label: "Intersex", imageUrl: `${process.env.PUBLIC_URL}/identitiescard/I-Intersex.png`},
  { code: "201", label: "LGBTQ", imageUrl: `${process.env.PUBLIC_URL}/identitiescard/Q-LGBTQ.png`},
  { code: "202", label: "Lesbian", imageUrl: `${process.env.PUBLIC_URL}/identitiescard/Q-Lesbian.png`},
  { code: "203", label: "Sapphic", imageUrl: `${process.env.PUBLIC_URL}/identitiescard/Q-Sapphic.png`},
  { code: "204", label: "Enbian", imageUrl: `${process.env.PUBLIC_URL}/identitiescard/Q-Enbian.png`},
  { code: "205", label: "Gay", imageUrl: `${process.env.PUBLIC_URL}/identitiescard/Q-Gay.png`},
  { code: "206", label: "Achillean", imageUrl: `${process.env.PUBLIC_URL}/identitiescard/Q-Achillean.png`},
  { code: "207", label: "Bisexual", imageUrl: `${process.env.PUBLIC_URL}/identitiescard/Q-Bisexual.png`},
  { code: "208", label: "Polysexual", imageUrl: `${process.env.PUBLIC_URL}/identitiescard/Q-Polysexual.png`},
  { code: "209", label: "Omnisexual", imageUrl: `${process.env.PUBLIC_URL}/identitiescard/Q-Omnisexual.png`},
  { code: "210", label: "Pansexual", imageUrl: `${process.env.PUBLIC_URL}/identitiescard/Q-Pansexual.png`},
  { code: "211", label: "Abrosexual", imageUrl: `${process.env.PUBLIC_URL}/identitiescard/Q-Abrosexual.png`},
  { code: "212", label: "Asexual", imageUrl: `${process.env.PUBLIC_URL}/identitiescard/Q-Asexual.png`},
  { code: "213", label: "Demisexual", imageUrl: `${process.env.PUBLIC_URL}/identitiescard/Q-Demisexual.png`},
  { code: "214", label: "Aromantic", imageUrl: `${process.env.PUBLIC_URL}/identitiescard/Q-Aromantic.png`},
  { code: "215", label: "Demiromantic", imageUrl: `${process.env.PUBLIC_URL}/identitiescard/Q-Demiromantic.png`},
  { code: "216", label: "Polyamorous", imageUrl: `${process.env.PUBLIC_URL}/identitiescard/Q-Polyamorous.png`},
  { code: "301", label: "Neopronouns", imageUrl: `${process.env.PUBLIC_URL}/identitiescard/F-Neopronouns.png`},
  { code: "302", label: "Progress Pride IC", imageUrl: `${process.env.PUBLIC_URL}/identitiescard/F-Progress Pride IC.png`},
  { code: "303", label: "Progress Pride", imageUrl: `${process.env.PUBLIC_URL}/identitiescard/F-Progress Pride.png`},
  { code: "304", label: "Hostages Stripe Rainbow Flag", imageUrl: `${process.env.PUBLIC_URL}/identitiescard/F-Hostages Stripe Rainbow Flag.jpg`},
  { code: "305", label: "Rainbow Israel Flag", imageUrl: `${process.env.PUBLIC_URL}/identitiescard/F-Rainbow Israel Flag.png`},
  { code: "306", label: "Unlabeled", imageUrl: `${process.env.PUBLIC_URL}/identitiescard/F-Unlabeled.png` },
  // Add more flags as needed
];

const HomeAc = () => {
  const [userData, setUserData] = useState({
    nickname: '',
    pronounscard: {
      pronouns: [],
      flags: [],
      timezone: '',
      profileImage: '',
      description: ''
    }
  });

  const [newNickname, setNewNickname] = useState('');
  const [newTimezone, setNewTimezone] = useState('');
  const [newProfileImage, setNewProfileImage] = useState('');
  const [newDescription, setNewDescription] = useState('');

  // Pronouns and flags selection states
  const [selectedPronouns, setSelectedPronouns] = useState([]);
  const [selectedFlags, setSelectedFlags] = useState([]);

  useEffect(() => {
    const user = auth.currentUser;

    if (user) {
      const formatEmailForDatabaseKey = (email) => {
        return email.replace(/\./g, '_').replace(/@/, '_'); // Format email for database key
      };

      const userEmail = formatEmailForDatabaseKey(user.email);
      const userRef = database.ref(`users/${userEmail}`);

      // Fetch user data
      userRef.on('value', (snapshot) => {
        const data = snapshot.val();
        if (data) {
          setUserData(data);
          setSelectedPronouns(data.pronounscard.pronouns || []); // Update selected pronouns
          setSelectedFlags(data.pronounscard.flags || []); // Update selected flags
        }
      });

      // Clean up listener on component unmount
      return () => userRef.off();
    }
  }, []);

  const handleClickAA = () => {
    // Construct the link using the user's nickname
    const link = `https://enbybase.web.app/u/${userData.nickname}`;
    
    // Copy the link to the clipboard
    navigator.clipboard.writeText(link)
      .then(() => {
        alert('Link copied to clipboard!');
        
        // Redirect the user after the clipboard action is successful
        window.location.href = `/u/${userData.nickname}`;
      })
      .catch((err) => {
        console.error('Failed to copy the link: ', err);
      });
  };
  

  const handlePronounSelect = (code) => {
    setSelectedPronouns((prev) =>
      prev.includes(code) ? prev.filter((p) => p !== code) : [...prev, code]
    );
  };

  const handleFlagSelect = (code) => {
    setSelectedFlags((prev) =>
      prev.includes(code) ? prev.filter((f) => f !== code) : [...prev, code]
    );
  };
  const handleSubmit = () => {
    const user = auth.currentUser;

    if (user) {
      const userEmail = user.email.replace(/\./g, '_').replace(/@/, '_'); // Format email for database key
      const userRef = database.ref(`users/${userEmail}`);

      const updates = {};

      // Update fields only if they are changed
      if (newNickname) updates.nickname = newNickname; // Update nickname if new value is provided
      if (newTimezone) updates['pronounscard/timezone'] = newTimezone; // Update timezone if new value is provided
      if (newProfileImage) updates['pronounscard/profileImage'] = newProfileImage; // Update profile image if new value is provided
      if (newDescription) updates['pronounscard/description'] = newDescription; // Update description if new value is provided
      if (selectedPronouns.length > 0) updates['pronounscard/pronouns'] = selectedPronouns; // Update pronouns if selected
      if (selectedFlags.length > 0) updates['pronounscard/flags'] = selectedFlags; // Update flags if selected

      // Update user data
      userRef.update(updates)
        .then(() => {
          alert("User data updated successfully.");
          // Reset selections and inputs after submission
          setSelectedPronouns([]);
          setSelectedFlags([]);
          setNewNickname('');
          setNewTimezone('');
          setNewProfileImage('');
          setNewDescription('');
        })
        .catch((error) => {
          console.error("Error updating user data:", error);
        });
    }
  };

  return (<><button className="logoutoverlaybtn" onClick={handleLogout}>
    Logout
  </button>
  <button className="logoutoverlaybtnaa" onClick={handleClickAA}>
    
  <svg
        fill="#000000"
        height="10px"
        width="10px"
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 458.624 458.624"
        xmlSpace="preserve"
        style={{
          filter: 'drop-shadow(4px 4px 6px rgba(0, 0, 0, 0.3))',
          stroke: '#EEEEEE',
          fill: '#FFFFFF',
          strokeWidth: 8,
        }}
      >
        <g>
          <g>
            <path d="M339.588,314.529c-14.215,0-27.456,4.133-38.621,11.239l-112.682-78.67c1.809-6.315,2.798-12.976,2.798-19.871
                c0-6.896-0.989-13.557-2.798-19.871l109.64-76.547c11.764,8.356,26.133,13.286,41.662,13.286c39.79,0,72.047-32.257,72.047-72.047
                C411.634,32.258,379.378,0,339.588,0c-39.79,0-72.047,32.257-72.047,72.047c0,5.255,0.578,10.373,1.646,15.308l-112.424,78.491
                c-10.974-6.759-23.892-10.666-37.727-10.666c-39.79,0-72.047,32.257-72.047,72.047s32.256,72.047,72.047,72.047
                c13.834,0,26.753-3.907,37.727-10.666l113.292,79.097c-1.629,6.017-2.514,12.34-2.514,18.872c0,39.79,32.257,72.047,72.047,72.047
                c39.79,0,72.047-32.257,72.047-72.047C411.635,346.787,379.378,314.529,339.588,314.529z"/>
          </g>
        </g>
      </svg>
       Share
  </button>
  <div className='recruitstaff'><div
        id="ctl00_SPWebPart"
        className="pnl-banner Anonymous-Users-Only"
        style={{
          margin: "4.5rem auto -4rem",
          borderRadius: "3px",
          display: "flex",
          width: "600px",
          height: "3.2rem",
          backgroundColor: "rgba(255, 255, 255, 0.75)",
          boxShadow: "rgba(0, 0, 0, 0.1) 0px 1px 4px 0px",
          fontSize: "1.145rem",
          color: "rgb(35, 51, 65)",
          boxSizing: "border-box",
          fontFamily: "FoundryContextW03Md, Rubik, Arial",
          font: "16px FoundryContextW03Md, Rubik, Arial",
          letterSpacing: "-0.5px",
          marginTop: '50px',
          top:'50px',
            transition: 'margin-right 2s',
            textAlign:'center'
        }}
      >
        <div
          className="engine-banner"
          style={{
            margin: "0px auto",
            display: "flex",
            boxSizing: "border-box",
            WebkitBoxAlign: "center",
            alignItems: "center",
          }}
        >
          <div className="banner-desktop" style={{ boxSizing: "border-box" }}>
          Need helping with changing passwords?
          </div>
          <div
            className="banner-lnk"
            style={{
              boxSizing: "border-box",
              margin: "0px 0.6rem",
              fontWeight: 500,
              color: "rgb(27, 53, 143)",
              fontSize: "1.13rem",
            }}
          >
          </div>
          <div style={{ boxSizing: "border-box" }}>
            <button
              className="banner-btn"
              type="button"
              aria-label="To make this website accessible to screen reader, Press combination of alt and 1 keys. To stop getting this message, press the combination of alt and 2 keys"
              style={{
                boxSizing: "border-box",
                border: "2px solid #9c59d1",
                borderRadius: "3px",
                padding: "0.35rem 1rem",
                fontWeight: 700,
                fontSize: "0.8rem",
                lineHeight: "1.25rem",
                cursor: "pointer",
                backgroundColor: "rgb(255, 255, 255)",
              }}
            >
            <a
              aria-label="To make this website accessible to screen reader, Press combination of alt and 1 keys. To stop getting this message, press the combination of alt and 2 keys"
              href="/changepassword"
              style={{
                boxSizing: "border-box",
                textDecoration: "none",
                color: "#9c59d1",
              }}
            >
              Click here
            </a>
            </button>
          </div>
        </div>
      </div>
      
      </div>
      
    <div className="container-pc" style={{fontFamily: 'Rubik-Regular'}}>
      <h1 style={{fontFamily: 'Rubik-Medium'}}>Update User Settings</h1>
      <div className="input-group-pc">
        <label>
          Nickname:
          <input style={{ fontFamily: 'Rubik-Regular' }}
            type="text"
            value={newNickname || userData.nickname}
            onChange={(e) => setNewNickname(e.target.value)}
            className="input-field-pc"
          />
        </label>
      </div>
      <div className="input-group-pc">
        <label>
          Timezone:
          <input style={{ fontFamily: 'Rubik-Regular' }}
            type="text"
            value={newTimezone || userData.pronounscard.timezone}
            onChange={(e) => setNewTimezone(e.target.value)}
            className="input-field-pc"
          />
        </label>
      </div>
      <div className="input-group-pc">
        <label>
          Profile Image URL:
          <input style={{ fontFamily: 'Rubik-Regular' }}
            type="text"
            value={newProfileImage || userData.pronounscard.profileImage}
            onChange={(e) => setNewProfileImage(e.target.value)}
            className="input-field-pc"
          />
        </label>
      </div>
      <div className="input-group-pc">
        Description: (Use \n for line break.)
      <textarea style={{ fontFamily: 'Rubik-Regular' }}
        value={newDescription || userData.pronounscard.description}
        onChange={(e) => setNewDescription(e.target.value)}
        className="input-field-pc"
      /></div>
      <div>
  <h2 style={{ fontFamily: 'Rubik-Medium' }}>Select Pronouns</h2>
  {pronounsList.map(({ code, label }) => (
    <button
      key={code}
      onClick={() => handlePronounSelect(code)}
      className={`option-button-pc ${selectedPronouns.includes(code) ? 'selected-pc' : ''}`}
      style={{ fontFamily: 'Rubik-Regular' }}
    >
      {label}
    </button>
  ))}
</div>
<div>
      <div>
        <h2 style={{ fontFamily: 'Rubik-Medium' }}>Select Flags</h2>
        <div className="flags-grid-pc">
          {flagsList.map(({ code, imageUrl }) => (
            <div
              key={code}
              className={`flag-item-pc ${selectedFlags.includes(code) ? 'selected-pc' : ''}`}
              onClick={() => handleFlagSelect(code)}
            >
              <img src={imageUrl} alt={`Flag ${code}`} className="flag-image-pc" />
            </div>
          ))}
        </div>
      </div></div>
      <button onClick={handleSubmit} className="confirm-button-pc" style={{fontFamily: 'Rubik-Regular'}}>Confirm</button>
    </div></>
  );
};

export default HomeAc;